// extracted by mini-css-extract-plugin
var _1 = "NavLink_navLink__XRj-m";
export { _1 as "navLink" }
